import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Notifications } from '@mui/icons-material';

// Styled components
const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(5, 2),
  minHeight: '80vh',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 1),
  },
}));

const Header = ({ children }) => (
  <Box sx={{ textAlign: 'center', mb: 5 }}>
    {children}
  </Box>
);

const ComingSoonBadge = styled(Box)(({ theme }) => ({
  background: `linear-gradient(45deg, ${theme.palette.warning.light} 30%, ${theme.palette.warning.main} 90%)`,
  borderRadius: theme.shape.borderRadius * 5,
  color: theme.palette.common.white,
  padding: theme.spacing(0.75, 2),
  fontWeight: theme.typography.fontWeightBold,
  fontSize: '0.75rem',
  textTransform: 'uppercase',
  marginBottom: theme.spacing(2),
  letterSpacing: '1px',
  boxShadow: theme.shadows[3],
}));

const GetNotifiedButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(5),
  borderRadius: theme.shape.borderRadius * 7.5,
  padding: theme.spacing(1.25, 3),
  fontWeight: theme.typography.fontWeightBold,
  boxShadow: theme.shadows[4],
  transition: theme.transitions.create(['transform', 'box-shadow'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: theme.shadows[6],
  },
}));

const ReportPage = () => {
  const [loadingProgress, setLoadingProgress] = useState(0);

  useEffect(() => {
    let animationFrame;
    const updateProgress = () => {
      setLoadingProgress((prev) => {
        if (prev >= 75) return 75;
        return prev + 0.5;
      });
      animationFrame = requestAnimationFrame(updateProgress);
    };
    animationFrame = requestAnimationFrame(updateProgress);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  const handleNotify = () => {
    // TODO: Implement notification subscription logic
    console.log('Notification requested');
  };

  return (
    <Container>
      <Header>
        <Typography
          variant="h3"
          component="h1"
          fontWeight="700"
          gutterBottom
          sx={{ fontSize: { xs: '2rem', sm: '3rem' } }}
        >
          Reports Dashboard
        </Typography>
        <ComingSoonBadge>Coming Soon</ComingSoonBadge>
        <Typography
          variant="h6"
          color="text.primary"
          sx={{ maxWidth: 600, mx: 'auto', mb: 3 }}
        >
          We're building powerful analytics tools to give you actionable insights.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 4 }}>
          <Box sx={{ position: 'relative', display: 'inline-flex', mr: 2 }}>
            <CircularProgress
              variant="determinate"
              value={loadingProgress}
              size={60}
              thickness={4}
              sx={{ color: 'primary.main' }}
              aria-label={`Development progress: ${Math.round(loadingProgress)}%`}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" color="primary" fontWeight="bold">
                {`${Math.round(loadingProgress)}%`}
              </Typography>
            </Box>
          </Box>
          <Typography variant="body1" fontWeight="medium">
            Development in progress
          </Typography>
        </Box>
      </Header>

      {/* <GetNotifiedButton
        variant="contained"
        color="primary"
        startIcon={<Notifications />}
        aria-label="Get notified when reports are ready"
        onClick={handleNotify}
      >
        Notify Me When Ready
      </GetNotifiedButton> */}

      <Typography
        variant="body2"
        color="text.primary"
        // sx={{ mt: 3, textAlign: 'center', maxWidth: 500 }}
        sx={{ mt: 0, textAlign: 'center', maxWidth: 500 }}
      >
        Our team is putting the finishing touches on these powerful analytics tools.
        We'll notify you as soon as they're ready for you to use!
      </Typography>
    </Container>
  );
};

export default ReportPage;